let loadPromise: Promise<void> | null = null;

const isWidgetReady = () => typeof (window as any).YooMoneyCheckoutWidget === 'function';

export async function loadCheckoutWidget(): Promise<void> {
  if (loadPromise) {
    return loadPromise;
  }

  if (isWidgetReady()) {
    return Promise.resolve();
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = '/assets/js/checkout-widget.js';
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
      let attempts = 0;
      const poll = () => {
        if (isWidgetReady()) {
          resolve();
        } else if (attempts++ < 20) {
          setTimeout(poll, 100);
        } else {
          loadPromise = null;
          reject(new Error('YooMoneyCheckoutWidget not available after script load'));
        }
      };
      poll();
    };

    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load checkout widget script'));
    };

    document.body.appendChild(script);
  });

  return loadPromise;
}
